import script from "./team-effectiveness-highlights-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./team-effectiveness-highlights-page.vue?vue&type=script&setup=true&lang=ts"

import "./team-effectiveness-highlights-page.vue?vue&type=style&index=0&id=14f10ab1&lang=less"

const __exports__ = script;

export default __exports__